<template>
  <modal :show.sync="isActiveLocal" size="md" header-classes="bg-primary p-3">
    <h6
      slot="header"
      class="modal-title uppercase text-white font-semibold pt-1"
    >
      Create Sender ID / Header
    </h6>

    <div>
      <div>
        <base-input class="w-full" label="User">
          <select class="form-control">
            <option disabled="true">Select</option>
            <option>Self</option>
          </select>
        </base-input>
      </div>

      <div>
        <base-input class="w-full" label="Sender ID">
          <b-input placeholder="Type or Enter " />
          <span class="mt-2 text-xs">Max Length : 6 Alpha Chars Only.</span>
        </base-input>
      </div>
    </div>
    <template slot="footer">
      <base-button type="primary">Request Sender ID / Header </base-button>
      <base-button
        type="secondary"
        class="ml-auto"
        @click="isActiveLocal = false"
        >CLOSE</base-button
      >
    </template>
  </modal>
</template>
<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
};
</script>
